import React from 'react';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import { IconButton } from '@material-ui/core';
import RemoveGroupPatientModal from '../../components/RemoveGroupPatientModal';
import PatientSearchUnderProvider from './PatientSearchUnderProvider';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
// import { enqueueSnackbar } from 'notistack';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {
    CircularProgress
} from '@material-ui/core';
import {
    fetchProviderGroupMembers,
    removePatientFromGroup
} from '../../services/api/admin';

class ProviderMembersList extends React.Component {
    state = {
        patientInfo: [],
        openRemovePatientModal: false,
        patientId: '',
        pageIndex: 0,
        pageLimit: 10,
        forwardClick: false,
        backClick: false,
        isLoading: true,
        clearInputBox:false
    }

    componentDidMount() {
        this.getProviderGroupMember(this.state.pageLimit, this.state.pageIndex);
    }

    async componentDidUpdate() {
        if (this.state.forwardClick === true) {
            const patientInfo = await fetchProviderGroupMembers(this.props.providerId, this.state.pageLimit, this.state.pageIndex * 10);
            this.setState({
                patientInfo: patientInfo.data,
                forwardClick: false,
                backwardClick: false,
                isLoading: false
            })
        } if (this.state.backwardClick === true) {
            const patientInfo = await fetchProviderGroupMembers(this.props.providerId, this.state.pageLimit, this.state.pageIndex * 10);
            this.setState({
                patientInfo: patientInfo.data,
                forwardClick: false,
                backwardClick: false,
                isLoading: false
            })
        }
    }

    openRemovePatientModal = async (Id) => {
        this.setState({
            openRemovePatientModal: true,
            patientId: Id.id
        })
    }

    onCloseModal = () => {
        this.setState({
            openRemovePatientModal: false,
        });
    }

    onRemovePatientSubmit = async () => {
        await removePatientFromGroup(this.state.patientId);
        const patientInfo = await fetchProviderGroupMembers(this.props.providerId, this.state.pageLimit, this.state.pageIndex * 10);
        this.setState({
            openRemovePatientModal: false,
            clearInputBox : true,
            patientInfo: patientInfo.data,
        });
    }

    getProviderGroupMember = async (pageLimit, pageIndex) => {
        const patientInfo = await fetchProviderGroupMembers(this.props.providerId, pageLimit, pageIndex * 10);
        this.setState({
            patientInfo: patientInfo.data,
            isLoading: false
        })
    }

    onPageForward = async () => {
        const { pageIndex } = this.state;
        this.setState({
            pageIndex: pageIndex + 1,
            forwardClick: true,
            isLoading: true
        })
    };

    onPageBack = async () => {
        const { pageIndex } = this.state;
        const { enqueueSnackbar } = this.props;
        if (pageIndex === 0) {
            enqueueSnackbar('You are on the first page');
        }
        else {
            this.setState({
                pageIndex: pageIndex - 1,
                backwardClick: true,
                isLoading: true
            })
        }
    };

    handleSelect = async(patient) => {
        let patientId = patient.patientInfo.patientId;
        const patientInfo = await fetchProviderGroupMembers(this.props.providerId, undefined, undefined,patientId);
        this.setState({
            patientInfo: patientInfo.data,
            clearInputBox : false
        })
    }

    handleRender = (list)=>{
        this.setState({
            patientInfo : list.data,
            clearInputBox : true,
        })
    }

    render() {
        const { patientInfo, pageLimit, pageIndex } = this.state;
        return (
            <>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={this.props.open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Patients List
                            </Typography>
                            <PatientSearchUnderProvider
                                label="Search Patient Under Group"
                                onSelect={(p)=>this.handleSelect(p)}
                                providerId={this.props.providerId}
                                className={this.props.classes.selectInput}
                                handleRender={(list)=>this.handleRender(list)}
                                clearInputBox = {this.state.clearInputBox}
                                patientInfo={this.state.patientInfo}
                            />
                            {
                                this.state.isLoading ? <div className={this.props.classes.loading}>
                                    <CircularProgress />
                                </div> :

                                    <Table size="small" aria-label="purchases">
                                        <TableHead>
                                            {patientInfo && patientInfo.length > 0 ?
                                                <TableRow>
                                                    <TableCell>Patient-Name</TableCell>
                                                    <TableCell>Patient-Email</TableCell>
                                                    <TableCell>Patient-PhoneNo</TableCell>
                                                </TableRow> : null
                                            }
                                        </TableHead>
                                        <TableBody>
                                            {
                                                patientInfo && patientInfo.length > 0 ? patientInfo.map(result => (
                                                    <TableRow key={result.id}>
                                                        <TableCell component="th" scope="row">
                                                            {result.patientInfo.patientFullName}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {result.patientInfo.patientEmail}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {result.patientInfo.patientPhone}
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton
                                                                //className={classes.marginLeftTen}
                                                                size="small"
                                                                aria-label="removePatient"
                                                                title="removePatient"
                                                                color="primary"
                                                                onClick={() => this.openRemovePatientModal(result)}
                                                            >
                                                                <DeleteSweepIcon color="primary" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )) : null
                                            }
                                        </TableBody>
                                    </Table>
                            }
                            <div className={this.props.classes.pageTurners}>
                                <IconButton disabled={pageIndex === 0}>
                                    <ArrowBackIosIcon
                                        style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                                        color="primary"
                                        variant="contained"
                                        onClick={this.onPageBack}
                                    />
                                </IconButton>
                                <IconButton disabled={patientInfo && patientInfo.length < pageLimit}>
                                    <ArrowForwardIosIcon
                                        style={{ opacity: patientInfo && patientInfo.length < pageLimit ? '0.5' : '1.0' }}
                                        color="primary"
                                        variant="contained"
                                        onClick={this.onPageForward}
                                    />
                                </IconButton>
                            </div>
                        </Box>
                    </Collapse>
                </TableCell>
                {
                    this.state.openRemovePatientModal &&
                    <RemoveGroupPatientModal
                        open={this.state.openRemovePatientModal}
                        onClose={this.onCloseModal}
                        save={this.onRemovePatientSubmit}
                    />
                }
            </>
        )
    }
}


const styles = () => ({
    loading: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    root: {
        padding: '3em',
    },
    list: {
        paddingBottom: '2em',
    },
    actions: {
        textAlign: 'right',
    },
    button: {
        marginLeft: '20px',
    },
    mergeButton: {
        marginLeft: '20px',
        color: 'black',
        backgroundColor: '#FFF6BF',
        '&:hover': {
            marginLeft: '20px',
            color: 'black',
            backgroundColor: '#cdc48d',
        },
    },
    pageTurners: {
        width: '100%',
        marginTop: '5px',
        display: 'flex',
        justifyContent: 'space-between'
    },
    container: {
        padding: '3em',
    },
    appBar: {
        zIndex: 10,
    },
    header: {
        paddingBottom: '3em',
    },
    headerText: {
        fontWeight: 'normal',
        fontSize: '1.8em',
        lineHeight: '19px',
        color: '#1C1C1C',
        paddingBottom: '0.5em',
    },
    helpText: {
        paddingBottom: '0.5em',
    },
    marginLeftAuto: {
        marginLeft: 'auto',
    },
    marginLeftTen: {
        marginLeft: 6,
    },
    selectInput: {
        marginTop: '0.5em',
        marginBottom: '1em',
    },
});

export default withSnackbar(
    withStyles(styles)(ProviderMembersList)
);
